
        
        <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
          <div class="card-header">Item Category</div> 
            <div class="card-body">
              <form  [formGroup] ="itemCategoryForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">

              <div class="row">
              <div class="form-group">
                <input  name="id" readonly formControlName="id"  class="form-control"    type="hidden">
                </div>
              <div class="col-sm-6 pb-1">
              <div class="form-group">
                <label for="itemCategory" class="col-form-label">Item Category</label>          
                <div class="input-group">
                  <div class="input-group-prepend">
                <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-boxes"></i></span>
                </div>
                <input  formControlName="itemCategory" [ngClass]="{'dark-input-field' : isDark }" placeholder="Item Category"  class="form-control" [class.is-invalid]="formErrors.itemCategory" (blur)="logValidationErrors()"   type="text">
                  </div>
                  <span class="text-danger" *ngIf="formErrors.itemCategory"><small>{{formErrors.itemCategory}}</small> </span>   
                </div>
                </div>

                <div class="col-sm-4 pt-3">
                  <button *ngIf="crud_access.create"  type="submit" class="btn btn-primary mt-4">
                    <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Save
                  </button>  
                </div>
            </div>                            
            </form>
      
            <br>
         
    
            <div class="row mt-2 mr-3">
              <div class="input-group col-md-12">                               
               <mat-form-field class="example-form-field">
                 <mat-label  [ngClass]="{'dark-bg' : isDark }">Search</mat-label>  
                 <span matPrefix><i class="fas fa-search">&nbsp; &nbsp;</i></span>                    
                 <input matInput type="text" [(ngModel)]="searchKey" autocomplete="off" (keyup)="applyFilter()">
                 <span class="input-group-append" matSuffix>
                   <button class="btn  border-0" type="button">
                       <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
                   </button>
                 </span> 
               </mat-form-field>      
             </div>      
           </div>
           
                   <div>
                     <mat-table [dataSource]="dataSource" matSort>
                      
                       <ng-container matColumnDef="itemCategory">
                         <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> Item Category </mat-header-cell>
                         <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.ItemCategory }} </mat-cell>
                       </ng-container>
                                
    
        
                       <ng-container matColumnDef="createdBy">
                        <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> CreatedBy </mat-header-cell>
                        <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
                      </ng-container>
           
                       <ng-container matColumnDef="action">
                         <mat-header-cell *matHeaderCellDef  [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
                         <mat-cell *matCellDef="let row"  [ngClass]="{'dark-bg' : isDark }">
                          <button *ngIf="crud_access.delete"  class="btn btn-danger btn-sm ml-1 text-white"  (click)="deleteButtonClick(row.Id)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button>      
                         </mat-cell>
                       </ng-container>
           
                       <ng-container matColumnDef="loading">
                         <mat-footer-cell *matFooterCellDef colspan="6"  [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
                       </ng-container>
           
                       <ng-container matColumnDef="noData">
                         <mat-footer-cell *matFooterCellDef colspan="6"  [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
                       </ng-container>
                     
                       <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                       <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                       <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
                       <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
                     </mat-table>
           
                     <mat-paginator  [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
           
                     </div>
           
           
                    </div> <!-- /.card-body -->
                  </div>   <!-- /.card -->    
  
           <script>
           
             $(function () {
             $('[data-toggle="viewTooltip"]').tooltip()
           })
           $(function () {
             $('[data-toggle="deleteTooltip"]').tooltip()
           })
           </script>
      
        
        
        
